export const config = {
  tournamentTitle: process.env.REACT_APP_TOURNAMENT_TITLE,
  tournamentDescription: process.env.REACT_APP_TOURNAMENT_DESCRIPTION,
  halftimeDuration: 10 * 60,
} as const;
